export function IconCopyLink(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 18 23" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M3.5 4.5V19l.008.09.023.084a.5.5 0 00.38.318L4 19.5h9.5v3H.5v-18h3zm9-4V5a.5.5 0 00.5.5h4.5v13h-13V.5h8zm1 .707L16.793 4.5H13.5V1.207z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </svg>
  );
}
